<script setup>
import AppFooter from '@/components/AppFooter.vue';
import NavBar from '@/components/navigation/NavBar.vue';
import OverlayComponent from '@/components/OverlayComponent.vue';
import LoadingState from "@/components/shared/LoadingState.vue";

const props = defineProps({
  // sideImage: {
  //   default: '/images/sideImage.jpg',
  //   type: String,
  //   required: false
  // },
  loading: {
    default: false,
    type: Boolean
  },
  onCancel: {
    default: () => {},
    type: Function
  }
});
</script>

<template>
  <LoadingState
    :loading="props.loading"
    :on-cancel="props.onCancel"
  />
  <NavBar />

  <div class="relative min-h-full grid grid-cols-1 md:grid-cols-2">
    <div>
      <slot name="content" />
    </div>
    <div class="relative flex-grow hidden md:block">
      <div
        style="background-image: url('/images/sideImage.jpg')"
        class="absolute -z-20 w-full min-h-dvh bg-cover bg-scroll bg-center"
      />
      <OverlayComponent />
    </div>
  </div>
  <AppFooter class="relative" />
</template>

<style scoped></style>
